import { PricingTierId } from '@business/entities/order';
import { CategoryResponse, CategoryId } from '../category';
import { PricingTierResponse } from '../order';
import { ServiceClassResponse } from './../project/ServiceClassResponse';
import { ProjectServiceId } from '../project';
import { VeryCompactOrgResponse } from '../organization';
import { CommissionTypeId } from './CommissionTypeResponse';

export type CommissionId = string;

export interface CommissionResponse {
  id: CommissionId;
  value: number;
  tiers: PricingTierResponse[];
  tierIds: PricingTierId[];
  categories: CategoryResponse[];
  classes: ServiceClassResponse[];
  services: ProjectServiceId[];
  timematerial: ProjectServiceId[];
  projects: string[];
  boards: string[];
  /** Work order fees (estimator template fee ids) the rule pays on the work order's first payment */
  fees: string[];
  invoiceType: CommissionInvoiceType;
  settings: CommissionRowSettingsResponse;
}

export interface CommissionRowSettingsResponse {
  excludeOrgs: VeryCompactOrgResponse[];
  includeOrgs: VeryCompactOrgResponse[];
  excludeCategories: CategoryId[];
  includeCategories: CategoryId[];
  excludeServices: ProjectServiceId[];
  includeServices: ProjectServiceId[];
  discountPercentage: string;
  customFields: Record<string, string>;
  /** Commission type (payroll code) of the lines this rule creates */
  typeId: CommissionTypeId | null;
}

export interface CommissionRequest {
  items: Partial<CommissionResponse>[];
}

export enum CommissionPeriod {
  weekly = 'weekly',
  biweekly = 'biweekly',
  bimonthly = 'bimonthly',
  monthly = 'monthly',
}

export enum CommissionInvoiceType {
  all = 'all',
  recurring = 'recurring',
  nonRecurring = 'nonRecurring',
}
